// src/page/info.jsx
import React, { useEffect, useState } from "react";
import { db } from "../firebase/config";
import { collection, getDocs } from "firebase/firestore";
import { Instagram, Facebook, Youtube } from "lucide-react";
import logo from "../asset/logoSumaSalto.png";
import { FaWhatsapp } from "react-icons/fa";

export default function Info() {
  const [comercios, setComercios] = useState([]);

  useEffect(() => {
    const fetchComercios = async () => {
      try {
        const snapshot = await getDocs(collection(db, "comercios"));
        const lista = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setComercios(lista);
      } catch (error) {
        console.error("Error cargando comercios:", error);
      }
    };
    fetchComercios();
  }, []);

  return (
     <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", color: "#333" }}>

{/* Header */}
<header style={{ backgroundColor: "#fcfcfcc4", boxShadow: "0 2px 6px rgba(0,0,0,0.2)" }}>
  <div
    style={{
      maxWidth: "1000px",
      margin: "0 auto",
      padding: "20px",   // 👈 mismo padding que main
      textAlign: "center", // 👈 alinear todo al centro
    }}
  >
    <img
      src={logo}
      alt="Logo Suma Salto"
      style={{
        maxWidth: "220px",
        width: "100%",
        height: "auto",
        margin: "0 auto 15px", // 👈 centrado automático
        display: "block",
      }}
    />
    <h1
      style={{
        fontSize: "24px",
        fontWeight: "bold",
        color: "#0f243dff",
        margin: 0,
        textAlign: "center", // 👈 centrado
      }}
    >
      Bienvenido a SumaSalto
    </h1>
    <p
      style={{
        marginTop: "10px",
        fontSize: "14px",
        color: "#0f243dff",
        textAlign: "center", // 👈 centrado
      }}
    >
      El primer sistema de puntos multi-comercio, con descuentos en efectivo real.
    </p>
  </div>
</header>
      {/* Contenedor principal con fondo celeste */}
      <main style={{ flex: 1, maxwidth: "1000px", backgroundColor: "#e0f2fe", padding: "40px 20px" }}>
    <div
      style={{
        maxWidth: "1000px",
        margin: "0 auto",
        backgroundColor: "white",
        borderRadius: "16px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        padding: "20px",
      }}
    >
          {/* Comercios adheridos */}
<section style={{ marginBottom: "40px" }}>
  <h2
    style={{
      fontSize: "20px",
      fontWeight: "600",
      textAlign: "center",
      color: "#1d4ed8",
      marginBottom: "15px",

    }}
  >
    <span style={{ color: "#0f243dff" }}>Comercios adheridos</span>
  </h2>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: "15px",
    }}
  >
    {comercios.length > 0 ? (
  comercios.map((c) => (
    <div
      key={c.id}
      style={{
        backgroundColor: "#f9fafb",
        borderRadius: "12px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        padding: "15px",
        textAlign: "center",
      }}
    >
      {c.logo && (
        <img
          src={c.logo}
          alt={c.nombre}
          style={{
            height: "50px",
            margin: "0 auto 10px",
            objectFit: "contain",
          }}
        />
      )}

      <p style={{ fontWeight: "500", marginBottom: "5px" }}>{c.nombre}</p>
      {c.direccion && (
        <p style={{ fontSize: "14px", color: "#6b7280", marginBottom: "8px" }}>
          {c.direccion}
        </p>
      )}

      {/* Contenedor de botones */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
        marginTop: "10px"
      }}>
        {/* Botón WhatsApp */}
        {c.telefono && (
          <a
            href={`https://wa.me/${c.telefono}?text=Hola%20${c.nombre},%20quisiera%20hacer%20una%20consulta`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px 16px",
              backgroundColor: "#25D366",
              color: "white",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "500",
              textDecoration: "none",
            }}
            title="Contactar por WhatsApp"
          >
            <FaWhatsapp style={{ marginRight: "8px", fontSize: "20px" }} />
            WhatsApp
          </a>
        )}

        {/* Botón reseñas */}
        {c.linkPerfilGoogle && (
          <a
            href={c.linkPerfilGoogle}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "8px 16px",
              backgroundColor: "#1d4ed8",
              color: "white",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "500",
              textDecoration: "none",
            }}
            title={`Ver reseñas de ${c.nombre} en Google`}
          >
            ⭐ Reseñas
          </a>
        )}
      </div>
    </div>
  ))
) : (
  <p style={{ textAlign: "center", color: "#6b7280" }}>
    Cargando comercios...
  </p>
)}

  </div>
</section>


          {/* Cómo funciona */}
          <section style={{ marginBottom: "40px" }}>
            <h2 style={{ fontSize: "20px", fontWeight: "600", textAlign: "center", color: "#1d4ed8", marginBottom: "20px" }}>
              <span style={{ color: "#0f243dff" }}>¿Cómo funciona?</span>
            </h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "20px", textAlign: "center" }}>
              <div>
                <div style={{ fontSize: "36px", marginBottom: "10px" }}>🛒</div>
                <p>Comprá en un comercio adherido. Carga el monto de tu compra y convierte el dinero en puntos.</p>
                <p>Busca el kiosco en el comercio adherido, o pidele al cajero que te cargue el monto.</p>
                
              </div>
              <div>
                <div style={{ fontSize: "36px", marginBottom: "10px" }}>⭐</div>
                <p>Sumá puntos con tu PWACliente. En tu tarjeta veras tus puntos y los comercios habilitados para el canje</p>
                <p>Cada comercio te ofrece un valor del canje variable segun tu recorrido y las veces que lo visitaste.</p>
              </div>
              <div>
                <div style={{ fontSize: "36px", marginBottom: "10px" }}>💵</div>
                <p>Canjeá por descuentos en efectivo real. Cada comercio te muestra su valor del canje en tu tarjeta PWA Cliente 💰.</p>
                <p>El comercio recien visitado queda deshabilitado hasta que visites a otro.</p>
              </div>
            </div>
          </section>

          {/* Cómo instalar */}
          <section>
            <h2 style={{ fontSize: "20px", fontWeight: "600", textAlign: "center", color: "#1d4ed8", marginBottom: "20px" }}>
             <span style={{ color: "#0f243dff" }}>Instalá la PWACliente</span>
            </h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  borderRadius: "12px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  padding: "20px",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: "36px", marginBottom: "10px" }}>🤖</div>
                <h3 style={{ fontWeight: "600", marginBottom: "10px" }}>Android</h3>
                <p style={{ fontSize: "14px", color: "#4b5563" }}>
                  Abrí la app en tu navegador Chrome y seleccioná “Agregar a pantalla principal”.
                </p>
              </div>
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  borderRadius: "12px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  padding: "20px",
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: "36px", marginBottom: "10px" }}>🍎</div>
                <h3 style={{ fontWeight: "600", marginBottom: "10px" }}>iOS</h3>
                <p style={{ fontSize: "14px", color: "#4b5563" }}>
                  Abrí la app en Safari, tocá el ícono de compartir y luego seleccioná “Agregar a pantalla de inicio”.
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>

    {/* Footer */}
<footer style={{ backgroundColor: "#f9fcfcff", marginTop: "40px" }}>
  <div
    style={{
      maxWidth: "1000px",
      margin: "0 auto",
      padding: "20px", // 👈 mismo padding que el header
      textAlign: "center",
    }}
  >
    <div
      style={{
        marginBottom: "15px",
        display: "flex",
        justifyContent: "center",
        gap: "24px",
      }}
    >
      <a
        href="https://instagram.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
        style={{ color: "black" }}
      >
        <Instagram size={24} />
      </a>
      <a
        href="https://facebook.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
        style={{ color: "black" }}
      >
        <Facebook size={24} />
      </a>
      <a
        href="https://youtube.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="YouTube"
        style={{ color: "black" }}
      >
        <Youtube size={24} />
      </a>
    </div>

    <p style={{ fontSize: "14px", margin: 0, color: "#0f243dff" }}>
      Contacto:{" "}
      <a
        href="mailto:contacto@1montonx2.com"
        style={{ color: "#0f243dff", textDecoration: "underline" }}
      >
        contacto@1montonx2.com
      </a>{" "}
      | WhatsApp:{" "}
      <a
        href="https://wa.me/59899735787"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#0f243dff", textDecoration: "underline" }}
      >
        +598 99735787
      </a>
    </p>

    <p style={{ fontSize: "12px", marginTop: "8px", color: "#0f243dff" }}>
      © 2025 SumaSalto. Desarrollado por Augusto Rivero.
    </p>
  </div>
</footer>
    </div>
  );
}



